/// <reference path="../../Data/List/FormatLookupEditor.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerEditor("Matrix.Data.AccountPicker")
    export class AccountPicker extends FormatLookupPickerBase<FormatLookupEditorOptions, AccountRow>  {

        handleEditClick() {
            var dlg = new AccountPickerDialog();
            dlg.criteria = this.getFilterCriteria();
            dlg.value = this.values;
            dlg.dialogOpen();
            dlg.onSuccess = sel => {
                this.values = dlg.value;
                return true;
            }
        }

        protected getLookupKey() {
            return AccountRow.lookupKey;
        }

        protected displayName() {
            return "accounts";
        }
    }
}